import IconActionLink from './IconActionLink';

export default IconActionLink;
